import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function fileZodSchema({ required, multiple, accept, maxFileSize }: FormInputSchemaParams) {
	const acceptTokens = (accept ?? "")
		.split(",")
		.map((token) => token.trim().toLowerCase())
		.filter(Boolean);

	return z.array(z.instanceof(File, { message: "invalidFieldValue" })).superRefine((files, ctx) => {
		if (files.length === 0) {
			if (required) {
				ctx.addIssue({ code: "custom", message: "required" });
			}
			return;
		}

		if (!multiple && files.length > 1) {
			ctx.addIssue({ code: "custom", message: "invalidFieldValue" });
			return;
		}

		for (const file of files) {
			const name = file.name.toLowerCase();
			const type = file.type.toLowerCase();
			const isAccepted =
				acceptTokens.length === 0 ||
				acceptTokens.some((token) => {
					if (token.startsWith(".")) return name.endsWith(token);
					if (token.endsWith("/*")) return type.startsWith(token.slice(0, -1));
					return type === token;
				});

			if (!isAccepted) {
				ctx.addIssue({ code: "custom", message: "invalidFileType" });
				return;
			}

			if (file.size > (maxFileSize ?? 10) * 1024 * 1024) {
				ctx.addIssue({ code: "custom", message: "fileTooLarge" });
				return;
			}
		}
	});
}
